import Request from "../lib/request";
import { PROJECT_ID } from "../constants/storageKeys";
import { CONTACTS_API, PROJECTS_API } from "../constants/api";
import { PAGE } from "../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = page_number => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${CONTACTS_API}`,
    needToken: true,
    params: { [PAGE]: page_number }
  });
};

export const show = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${CONTACTS_API}/${id}`,
    needToken: true
  });
};

export const remove = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${CONTACTS_API}/${id}`,
    needToken: true
  });
};

export const store = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${CONTACTS_API}`,
    needToken: true,
    data: data
  });
};

export const update = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${CONTACTS_API}/${id}`,
    needToken: true,
    data: data
  });
};
